// src/services/cartService.js
import { orderApi } from '../utils/apiConfig';

export const cartService = {
  getCart: async () => {
    const response = await orderApi.get('/api/cart');
    return response.data;
  },
  addToCart: async (outletVariantId) => {
    const response = await orderApi.post(`/api/cart/add/${outletVariantId}`);
    return response.data;
  },
  increaseQuantity: async (cartItemId) => {
    const response = await orderApi.put(`/api/cart/increase/${cartItemId}`);
    return response.data;
  },
  decreaseQuantity: async (cartItemId) => {
    const response = await orderApi.put(`/api/cart/decrease/${cartItemId}`);
    return response.data;
  },
  removeFromCart: async (cartItemId) => {
    const response = await orderApi.delete(`/api/cart/remove/${cartItemId}`);
    return response.data;
  }
};